<template>
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body p-0">
            <section class="carousel___init" aria-label="Gallery">
              <ol class="carousel__viewport">
                
                <li class="carousel__slide" v-for="(item, index) in property.data" :key="index"  :id="'carousel__slide'+index">
                    <img class="hero__image" :src="item.attributes.url" alt="594 Columbia Ave" />
                    <div class="carousel__snapper">
                    <a :href="'#carousel__slide'+ (index == 0 ? property.data.length - index : index - 1)"
                      class="carousel__prev">Go to last slide</a>
                    <a :href="'#carousel__slide'+ (index == (property.data.length - 1) ? 0 : index + 1)"
                      class="carousel__next">Go to next slide</a>
                  </div>
                </li>
              </ol>
              <aside class="carousel__navigation">
                <ol class="carousel__navigation-list">
                  <li v-for="(item, index) in property.data" :key="index"  :id="'carousel__slide'+index" class="carousel__navigation-item">
                    <a :href="'#carousel__slide'+index"
                      class="carousel__navigation-button">Go to slide 1</a>
                  </li>
                </ol>
              </aside>
            </section>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'Carrousel',
  props: {
    property: {
      type: Object,
      required: false,
      default:{}
    }
  },
  created(){
    console.log('property---CARR', this.property.data)
  }
}
</script>
<style lang="scss">
/*
.modal-content {
  max-width: 565px;
  width: 100%;
  height: 500px;
  padding: 0;
  margin: 0;
}
.slider-c {
  width: 563px;
  padding: 0;
  margin: 0;
  list-style: none;
}
ul {
  list-style: none;
}
ul.slider {
  width: 600px;
  list-style: none;
  position:relative; 
}

ul.slider li {
    list-style: none;
    opacity: 0; 
    transition: opacity .5s;
    position: absolute;
    left: 0px;
    top: 0px;
}
ul.slider li:first-child {
    opacity: 1; 
}
ul.slider li:target {
    opacity: 1; 
}
.nav-slider {
  position: relative;
  top: 30px;

}*/
.hero__image {
  border-radius: 10px;
}
@keyframes tonext {
  75% {
    left: 0;
  }
  95% {
    left: 100%;
  }
  98% {
    left: 100%;
  }
  99% {
    left: 0;
  }
}

@keyframes tostart {
  75% {
    left: 0;
  }
  95% {
    left: -300%;
  }
  98% {
    left: -300%;
  }
  99% {
    left: 0;
  }
}

@keyframes snap {
  96% {
    scroll-snap-align: center;
  }
  97% {
    scroll-snap-align: none;
  }
  99% {
    scroll-snap-align: none;
  }
  100% {
    scroll-snap-align: center;
  }
}


ol, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.carousel___init {
  position: relative;
  padding-top: 58%;
  filter: drop-shadow(0 0 10px #0003);
  perspective: 100px;
  margin: 0;
}

.carousel__viewport {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  overflow-x: scroll;
  counter-reset: item;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
}

.carousel__slide {
  position: relative;
  flex: 0 0 100%;
  width: 100%;
  background-color: rgba(255, 0, 0, 0.5);
  counter-increment: item;
}

.carousel__slide:nth-child(even) {
  background-color: rgba(255, 0, 0, 0.5);
}

.carousel__slide:before {
  //content: counter(item);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%,-40%,70px);
  color: #fff;
  font-size: 2em;
}

.carousel__snapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  scroll-snap-align: center;
}

@media (hover: hover) {
  .carousel__snapper {
    animation-name: tonext, snap;
    animation-timing-function: ease;
    animation-duration: 4s;
    animation-iteration-count: infinite;
  }

  .carousel__slide:last-child .carousel__snapper {
    animation-name: tostart, snap;
  }
}

@media (prefers-reduced-motion: reduce) {
  .carousel__snapper {
    animation-name: none;
  }
}

.carousel___init:hover .carousel__snapper,
.carousel___init:focus-within .carousel__snapper {
  animation-name: none;
}

.carousel__navigation {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
}

.carousel__navigation-list,
.carousel__navigation-item {
  display: inline-block;
}

.carousel__navigation-button {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  background-color: #333;
  background-clip: content-box;
  border: 0.25rem solid transparent;
  border-radius: 50%;
  font-size: 0;
  transition: transform 0.1s;
}

.carousel___init::before,
.carousel___init::after,
.carousel__prev,
.carousel__next {
  position: absolute;
  top: 0;
  margin-top: 37.5%;
  width: 4rem;
  height: 4rem;
  transform: translateY(-50%);
  border-radius: 50%;
  font-size: 0;
  outline: 0;
}

.carousel___init::before,
.carousel__prev {
  left: -1rem;
}

.carousel___init::after,
.carousel__next {
  right: -1rem;
}

.carousel___init::before,
.carousel___init::after {
  content: '';
  z-index: 1;
  background-color: #333;
  background-size: 1.5rem 1.5rem;
  background-repeat: no-repeat;
  background-position: center center;
  color: #fff;
  font-size: 2.5rem;
  line-height: 4rem;
  text-align: center;
  pointer-events: none;
}

.carousel___init::before {
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='0,50 80,100 80,0' fill='%23fff'/%3E%3C/svg%3E");
}

.carousel___init::after {
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='100,50 20,100 20,0' fill='%23fff'/%3E%3C/svg%3E");
}
</style>